import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { Link } from "@remix-run/react";
import type { ProductFlatten } from "~/types";
import usaFlag from "../../images/badges/usa-flag.svg";
import logoFastShipping from "../../images/footer/fast_shipping_icon.svg";
import freeShipping from "../../images/footer/free_shipping_icon.svg";

function Badges({ product }: { product: ProductFlatten }) {
  const hasRegularShipping = product.tags.includes("CJ Dropshipping") || product.tags.includes("modalyst");
  const madeInUSA = product.tags.includes("Made in USA");
  return (
    <div className="flex flex-row flex-wrap justify-center pb-4 md:justify-start">
      {hasRegularShipping ? (
        <div className="flex min-w-[50%] py-2 md:min-w-[33%]">
          <img className="h-6 w-8" src={freeShipping} alt="Free Shipping" />
          <p className="mx-2">Free Shipping</p>
        </div>
      ) : (
        <div className="flex min-w-[50%] py-2 md:min-w-[33%]">
          <img className="h-6 w-8" src={logoFastShipping} alt="Free Fast Shipping" />
          <p className="ml-2">Free Fast Shipping</p>
        </div>
      )}
      <div className="flex min-w-[50%] py-2 md:min-w-[33%]">
        <CheckCircleIcon className="ml-2 h-7 w-7 text-green-400" aria-hidden="true" />
        <Link to="/help/return-policy" className="mx-2">
          Returns Accepted
        </Link>
      </div>
      {madeInUSA ? (
        <div className="flex min-w-[50%] justify-center py-2 md:min-w-[33%] md:justify-end">
          <img className="h-6 w-8" src={usaFlag} alt="Made in USA" />
          <p className="mx-2">Made in USA</p>
        </div>
      ) : null}
    </div>
  );
}

export default Badges;
